import { Controller } from "@hotwired/stimulus"

// A centred pop-up (<dialog>) opened by a button. Tapping outside it closes it, and it's closed before
// Turbo keeps a copy of the page, so the copy never shows it open.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.closeBeforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
